import React, {FC} from 'react'
import { Grid, Button } from 'semantic-ui-react'
//@ts-ignore
import LKPeriodButton from 'shared/LKPeriodButton'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import FormField from 'shared/newFormElements'
//@ts-ignore
import { GridContainer } from 'shared/StyledComponents'
//@ts-ignore
import LKGridExportButton from 'shared/LKGrid/ExportButton'

import translate from '../../translator'

import { OrderAddDropdown } from '../../../OrderAdd'

import { EntriesDateFilterProps } from '../../types.LoanDetails'

const DateFilters: FC<EntriesDateFilterProps> = ({ loading, setDateFiltersToOperDay, ID, hash, change, data, handleSubmit }) => (
  <GridContainer>
    <Grid>
      <Grid.Row columns={1}>
        <Grid.Column className="u-flex">
          <div className="u-fluid">
            <FormField type="range-date-picker-first-input" name="StartDate" />
          </div>

          <Button.Group className="u-marginLeft-5 u-marginRight-5">
            <LKPeriodButton startDateName="StartDate" endDateName="EndDate" change={change} />

            <LKButton alias="today" onClick={setDateFiltersToOperDay} />
          </Button.Group>

          <div className="u-fluid">
            <FormField
              form="loan-entries-details"
              startDateName="StartDate"
              endDateName="EndDate"
              type="range-date-picker"
            />
          </div>
        </Grid.Column>
      </Grid.Row>

      <Grid.Row columns={1}>
        <Grid.Column textAlign="right">
          <LKButton disabled={loading} onClick={handleSubmit} alias="refresh">
            {translate('cmd_refresh_accounts')}
          </LKButton>

          <OrderAddDropdown
            onOrderAdd={() => {
              if (data && data.length > 0) {
                handleSubmit()
              }
            }}
            alias="entry_add"
            LoanID={ID}
            LoanHash={hash}
            upward
          >
            {translate('cmd_new_acc_entry')}
          </OrderAddDropdown>

          <LKGridExportButton alias="export" instanceName={`Loan-Entries-${ID}`} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </GridContainer>
)

export default DateFilters
